import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInfinity: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconInfinity"><Path d="M12 12L15.3683 15.5355C17.2285 17.4882 20.2446 17.4882 22.1048 15.5355C23.9651 13.5829 23.9651 10.4171 22.1048 8.46447C20.2446 6.51184 17.2285 6.51184 15.3683 8.46447L12 12ZM12 12L8.63173 8.46447C6.77148 6.51184 3.75543 6.51184 1.89518 8.46447C0.0349387 10.4171 0.0349387 13.5829 1.89518 15.5355C3.75543 17.4882 6.77148 17.4882 8.63173 15.5355L12 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconInfinity;
